export default "__VITE_ASSET__56e3d141__"